import axios from 'axios'

const LAMBDA_URL = process.env.REACT_APP_LAMBDA_URL

export type ILicenseTypes = Record<string, string>

export const initAPI = {
  async getLicenseTypes(lang: string) {
    try {
      const response = await axios.get<ILicenseTypes>(
        `${LAMBDA_URL}/license-types/?lang=${lang}`
      )
      if (response.status === 200) return response.data
      return null
    } catch (error) {
      console.log(error)
    }
  }
}
